import { documentId, query, where } from 'firebase/firestore'
import type { MedicationAgreement } from '~/models'
import { MapService } from './serviceLive'

export class MedicationAgreementService extends MapService<MedicationAgreement> {
  constructor() {
    super('MedicationAgreement')
  }

  public listenForUserId(userId: string): void {
    const listenQuery = query(this.collection, where('UserId', '==', userId))
    this.listen(listenQuery)
  }

  public listenForId(medicationAgreementId: string): void {
    const listenQuery = query(
      this.collection,
      where(documentId(), '==', medicationAgreementId),
    )
    this.listen(listenQuery)
  }
}
